<!-- <p>incident-timline-graph works!</p> -->
<!-- <div class="aumye-header">
  Incident Status Timeline
  <button mat-mini-fab mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div> -->
<div class="demo-chart-wrapper">
  <div class="center-wrap">
    <div class="chart-scroll-container">
      <div
        echarts
        [options]="chartOption"
        [ngStyle]="
          height
            ? { height: height, width: getChartWidth() }
            : { width: getChartWidth() }
        "
        class="demo-chart"
      ></div>
    </div>
  </div>
</div>
